import app from '@/app';
import angular from 'angular';

var component = {
	templateUrl: '/app/entities/cost-table/cost-table-item-detail.html',
	controller: Controller,
	require: {
		parent: '^costTableDetail'
	},
	bindings: {
		$transition$: '<',
    allMaterialsServices: '<',
    allUnitPriceTable: '<'
	}
};

/* @ngInject */
function Controller($controller, $state, $timeout, Solution, Principal, $translate, $http, UnitPriceTable) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

  $ctrl.unitPriceTable = null;

	// Accept either an object with .id or an id (number/string)
	$ctrl.onUnitPriceTableChange = function(unitPriceTableParam) {
		var id = null;
		$ctrl.entity.compositions = [];
		if (!unitPriceTableParam) {
			$ctrl.allMaterialsServices = { content: [] };
			return;
		}
		if (angular.isObject(unitPriceTableParam) && unitPriceTableParam.id) {
			id = unitPriceTableParam.id;
		} else {
			// assume primitive id passed
			id = unitPriceTableParam;
		}
		if (!id) {
			$ctrl.allMaterialsServices = { content: [] };
			return;
		}
		$ctrl.loading = true;
		$http
			.get('api/materialsServices/unitPriceTable/' + id)
			.then(function(response) {
				var data = response.data;
				if (angular.isArray(data)) {
					$ctrl.allMaterialsServices = { content: data };
				} else {
					$ctrl.allMaterialsServices = data || { content: [] };
				}
			})
			.finally(function() {
				$ctrl.loading = false;
			});
	};

	// Helper to get unit price table name by id (used in ui-select-match)
	$ctrl.getUnitPriceTableName = function(id) {
		if (!id || !$ctrl.allUnitPriceTable || !$ctrl.allUnitPriceTable.content) return '';
		var found = $ctrl.allUnitPriceTable.content.find(function(u) {
			return u.id == id;
		});
		return found ? found.name : '';
	};

	// Predicate used by the view to filter materialsServices by the selected unitPriceTable id
	$ctrl.filterMaterialsServicesByUnitPriceTable = function(materialsServices) {
		if (!materialsServices) return false;
		if (!$ctrl.entity || !$ctrl.entity.unitPriceTablesId) {
			// no unitPriceTable selected -> show nothing
			return false;
		}
		return materialsServices.idUnitPriceTable == $ctrl.entity.unitPriceTablesId;
	};


  	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractController', { $ctrl: $ctrl });
	$ctrl.allSolution = null;
	var transition = $ctrl.transition;
	$ctrl.transition = function(params) {
		transition(params);
		if (params.iid === 'new') {
			$ctrl.origin = null;
			$ctrl.entity = { id: $ctrl.parent.idgen-- };
		} else {
			$ctrl.origin = _.find({ id: parseInt(params.iid) })($ctrl.parent.entity.items);
			$ctrl.entity = angular.extend({}, $ctrl.origin);
		}

		$ctrl.entity.compositions.forEach(element => {
			var composition = $ctrl.search(element.materialsServices);
			element.materialsServices.value = composition.value;
			element.materialsServices.unit = composition.unit;
		});

	};

	$ctrl.querySolutions = function(query) {
		$ctrl.loading = true;
		return Solution.all({ query: query, size: 10, sort: 'name,asc' }, function(data) {
			$ctrl.allSolutions = data;
			$ctrl.loading = false;
		}).$promise;
	};

  $ctrl.queryUnitPriceTable = function(query) {
		$ctrl.loading = true;
		return UnitPriceTable.query({ query: query, size: 10, sort: 'name,asc' }, function(data) {
			$ctrl.allUnitPriceTable = data;
			$ctrl.loading = false;
		}).$promise;
	};

	$ctrl.filterSolutions = function(value) {
		return (
			($ctrl.origin && $ctrl.origin.solution.id === value.id) ||
			$ctrl.parent.entity.items.every(function(item) {
				return item.solution.id !== value.id;
			})
		);
	};

	$ctrl.solutionError = null;

	$ctrl.save = function() {
		$ctrl.solutionError = null;
		var isDuplicate = $ctrl.parent.entity.items.some(function(item) {
			return item.solution && $ctrl.entity.solution &&
				item.solution.id === $ctrl.entity.solution.id &&
				item.id !== $ctrl.entity.id;
		});
		if (isDuplicate) {
			$ctrl.solutionError = $translate.instant('costTable.item.duplicateSolution');
			return;
		}
		$ctrl.entity.cost = $ctrl.calcCost();
		if ($ctrl.origin) {
			angular.extend($ctrl.origin, $ctrl.entity);
		} else {
			$ctrl.parent.entity.items.push($ctrl.entity);
		}
		$ctrl.parent.dirtyItems();
		$state.go('^');
	};

	$ctrl.errorMessage = null;

	$ctrl.addNewComposition = function() {
		if(!$ctrl.entity.compositions){
			$ctrl.entity.compositions = [];
		}
		$ctrl.entity.compositions.push({
			id: null,
			materialsServices: { id: null, name: null, value: 0, unit: 'noValue' },
			thickness: 0,
			applicationFee: 0,
			totalValueForUnit: 0,
			costTableItem: {"id":$ctrl.origin ? $ctrl.origin.id : null}
		});
	};

	$ctrl.clearUiSelect = function($event, $select, field) {
		$event.stopPropagation();
		$select.selected = null;
		$select.search = null;

		field = null;
	};

	$ctrl.calcTotalValueForUnit = function(item) {
		var result = item.materialsServices.value * (item.applicationFee/100) * item.thickness;
		item.totalValueForUnit = result;
		return result;
	};

	$ctrl.calcCost = function() {
		var result = 0;
		if($ctrl.entity.compositions && $ctrl.entity.compositions.length > 0){
			$ctrl.entity.compositions.forEach(element => {
				result = result + element.totalValueForUnit;
			});
		}
		$ctrl.entity.cost = result;
		return result;
	};

	$ctrl.search = function(item) {
		var result = $ctrl.allMaterialsServices.content.find(m => m.id == item.id);
		return result;
	};

	$ctrl.removeItem = index => {
		$ctrl.entity.compositions.splice(index, 1);
	};

	$ctrl.calcThickness = function(item) {
		var thickness;
		if(item.thickness == 0 && item.materialsServices.unit == "M2"){
			item.thickness = 1;
		}
		return thickness;
	};

	$ctrl.isLastItemNull = function() {
		// Check if the list exists and has elements
		if ($ctrl.entity.compositions && $ctrl.entity.compositions.length > 0) {
			// Get the last item
			var idLastMaterialItem = $ctrl.entity.compositions[$ctrl.entity.compositions.length - 1].materialsServices.id;
			// Return true if the last item is null, false otherwise
			return idLastMaterialItem === null;
		}
		// Return false if the list is empty or undefined
		return false;
	};

}

app.component('costTableItemDetail', component);
